<script setup lang="ts">
import { EntityFaqItems } from '~/components/entity/faq'
import type { IFaqItem } from '~/components/entity/faq'
import type { IProps } from '~/components/widget/faq-list/types'
import type { IResponseData } from '~/types'
import { useStripTags } from '~/composables/useStripTags'

const props = withDefaults(defineProps<IProps>(), {
  path: '/faq'
})

const url = computed(() => useUrlWithParams(props.path, { ...props.queryParams, page: 1 }))
const { data: faqs, status } = useApi<IResponseData<IFaqItem[]>>(() => computed(() => url.value), {
  key: `faqs-list.${url.value}`
})

watch(
  () => faqs.value?.data,
  (faqItems) => {
    if (!faqItems?.length) return

    useSchemaOrg([
      ...faqItems.map((faq) =>
        defineQuestion({
          name: faq.title,
          acceptedAnswer: useStripTags(faq.description)
        })
      )
    ])
  },
  { immediate: true }
)
</script>

<template>
  <section
    v-if="faqs && faqs.data.length && status === 'success'"
    class="Accordion"
    aria-labelledby="faq"
  >
    <Heading id="faq" tag="h2" class="sr-only">{{ $t('common.faq') }}</Heading>
    <EntityFaqItems :variant="props.variant" :items="faqs.data" />
  </section>
</template>
